module.exports = __webpack_public_path__ + "img/agis-pc.e41b3d67.png";